// Please note that to enable features or switches they must
// also be added to features.yml in the checkout code base
export default {
  APP_DARK_MODE: 'app_dark_mode',
  APPLE_PAY_WITHOUT_SAVED_CARD: 'apple_pay_without_saved_card',
  CAMPAIGN_BANNER: 'campaign_banner',
  CONFIRMATION_EMAIL_DELAY: 'confirmation_email_delay',
  COMBINED_PAYMENT_TYPES_ENABLED: 'combine_payment_types',
  DELIVERY_COLLECTION_RADIO_BUTTONS: 'delivery_collection_radio_buttons',
  DISABLE_APPLE_PAY: 'disable_apple_pay',
  DISABLE_CLEARPAY: 'disable_clearpay',
  DISABLE_GOOGLE_PAY: 'disable_google_pay',
  DISABLE_KLARNA: 'disable_klarna',
  DISABLE_KOUNT: 'disable_kount',
  DISABLE_PAYPAL: 'disable_paypal',
  DISABLE_YOTI: 'disable_yoti',
  EMERGENCY_DELIVERY_PAGE_MESSAGE: 'emergency_delivery_page_message',
  EMERGENCY_PAYMENT_PAGE_MESSAGE: 'emergency_payment_page_message',
  EMERGENCY_ORDER_CONFIRMATION_MESSAGE: 'emergency_order_confirmation_message',
  ENABLE_PAYPAL_EXPRESS: 'enable_paypal_express',
  FASTER_COLLECTION_PAGE: 'faster_collection_page',
  FIXED_BASKET_FOOTER: 'fixed_basket_footer',
  FORCE_CUSTOMER_APP_TYPE: 'force_customer_app_type',
  IGNORE_CUSTOMER_PAYMENT_PREFERENCE: 'ignore_customer_payment_preference',
  LOG_ANALYTICS: 'logAnalytics',
  MEMBERS_WEEK_MESSAGING: 'members_week_messaging',
  NO_MARKETING: 'no_marketing',
  PAYPAL_CLIENT_TOKEN_OVERRIDE: 'payPalClientTokenOverride',
  PREFERRED_DELIVERY_CHOICE: 'preferred_delivery_choice',
  PROMINENT_USE_LOCATION: 'prominent_use_location',
  SHIP_FROM_STORE_MESSAGE: 'ship_from_store_message',
  SHOW_CALL_CENTRE_NUMBER_ON_3DS_ERROR: 'show_call_centre_number_on_3ds_error',
  SHOW_RECOMMENDATIONS: 'show_recommendations',
  STRIPE_CHECKOUT_ENABLED: 'stripe_checkout_enabled',
  TEST_CRYPTOGRAM_IN_INTEGRATION: 'test_cryptogram_in_integration',
  TRA_EXTRA_VISA: 'tra_extra_visa',
  TRA_VISA_BINS: 'tra_visa_bins',
  USE_LOCAL_PAYPAL_SANDBOX_OVERRIDE: 'use_local_paypal_sandbox_override',
  USE_REAL_CLEARPAY: 'use_real_clearpay',
  USE_REAL_KLARNA: 'use_real_klarna',
  USE_REAL_LOQATE_OVERRIDE: 'use_real_loqate_override',
  USE_STUBBED_NEWRELIC: 'use_stubbed_newrelic',
};
